import { useMemo } from "react"

import { buildMetricRecordDataById } from "@/metrics/runtime/record-data"

import { useMetricsListRecordDataTransport } from "./useMetricsListRecordDataTransport"

export function useMetricRecordMetadataById() {
  const referencedMetricIds = useMemo<string[]>(() => [], [])
  const result = useMetricsListRecordDataTransport({
    enabled: undefined,
    referencedMetricIds,
  })
  const metricRecordsById = useMemo(
    () => buildMetricRecordDataById(result.data),
    [result.data],
  )
  return { ...result, metricRecordsById }
}
